import TableLoader from "Components/Common/Loader/TableLoader";
import ModalWrapper from "Components/Modal/ModalWrapper";
import Pagination from "Components/Pagination/Pagination";
import React, { useState } from "react";
import { HiOutlineStatusOffline, HiOutlineStatusOnline } from "react-icons/hi";
import UserDetailsPage from "Screens/Admin/UserDetailsPage";

const UsersTable = ({ users, loading, page, setPage, totalPages }) => {
  const [selectedUserId, setSelectedUserId] = useState(null);

  return (
    <div className="mx-auto mt-5 w-auto rounded-t-2xl">
      <div className="overflow-x-auto rounded-t-2xl">
        {loading ? (
          <TableLoader />
        ) : (
          <>
            <table className="w-full rounded-t-2xl text-left text-sm">
              <thead className="text-md bg-[#e0ced7] uppercase tracking-wide text-navy-900">
                <tr>
                  <th className="px-6 py-3">Sl No.</th>
                  <th className="px-6 py-3">Name</th>
                  <th className="px-6 py-3">Phone</th>
                  <th className="px-6 py-3">Language</th>
                  <th className="px-6 py-3">Status</th>
                </tr>
              </thead>
              <tbody>
                {users.length > 0 ? (
                  users.map((row, index) => (
                    <tr key={row._id || index} className="text-md bg-white tracking-wide text-gray-700">
                      <td className="border border-[#ddd9db] px-6 py-4">{(page - 1) * 5 + index + 1}</td>
                      <td
                        className="cursor-pointer border border-[#ddd9db] px-6 py-4"
                        onClick={() => setSelectedUserId(row._id)}
                      >
                        {row.nickName}
                      </td>
                      <td className="border border-[#ddd9db] px-6 py-4">{row.phone}</td>
                      <td className="border border-[#ddd9db] px-6 py-4">{row.preferred_Language}</td>
                      <td className="border border-[#ddd9db] px-6 py-4">
                        {row?.isOnline ? (
                          <div className="flex items-center gap-2">
                            <HiOutlineStatusOnline size={22} color="#16c913" />
                            <span className="text-[#16c913]">Online</span>
                          </div>
                        ) : (
                          <div className="flex items-center gap-2">
                            <HiOutlineStatusOffline size={22} color="#e00000" />
                            <span className="text-[#e00000]">Offline</span>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} className="text-center py-6 text-gray-500 italic">
                      No users found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Modal for user details */}
            <ModalWrapper isOpen={!!selectedUserId} onClose={() => setSelectedUserId(null)}>
              {selectedUserId && <UserDetailsPage id={selectedUserId} />}
            </ModalWrapper>

            {/* Pagination from backend */}
            {totalPages > 1 && (
              <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default UsersTable;
